import './index.scss'
import React from 'react'

/**
 * BannerCTA
 *
 * Reusable Call-to-Action banner with two optional buttons.
 * - By default, it shows a button to "/individual-software" and "/kontakt"
 *   but these can be customized via props.
 *
 * Props:
 * @param {string}  title                  - The CTA title
 * @param {string}  text                   - The CTA text
 * @param {boolean} noSpace                - Removes extra spacing if set
 * @param {boolean} noBackground           - Removes background styling if set
 * @param {boolean} hideIndividualButton   - Hide the 'individual-software' button if true
 * @param {boolean} hideContactButton      - Hide the 'contact' button if true
 * @param {string}  individualButtonUrl    - Custom URL for the first button (default "/individual-software")
 * @param {string}  contactButtonUrl       - Custom URL for the second button (default "/kontakt")
 * @param {string}  individualButtonText   - Label text for the first button (default "Mehr erfahren")
 * @param {string}  contactButtonText      - Label text for the second button (default "Kontaktieren Sie Uns!")
 */

const BannerCTA = ({
  title,
  text,
  noSpace,
  noBackground,
  hideIndividualButton,
  hideContactButton,
  individualButtonUrl = '/individual-software',
  contactButtonUrl = '/kontakt',
  individualButtonText = 'Mehr erfahren',
  contactButtonText = 'Kontaktieren Sie Uns!',
}) => {
  // Check if URLs are external (start with http:// or https://)
  const isExternalIndividual = !!individualButtonUrl.match(/^https?:\/\//i)

  return (
    <>
      <div
        className={`bannercta ${noSpace ? 'bannercta--no-space' : ''} ${noBackground ? 'bannercta--no-background' : ''}`}
      >
        <div className="container">
          <h2>{title}</h2>
          <p>{text}</p>
          <span>
            {hideIndividualButton ? null : (
              <a
                href={individualButtonUrl}
                target={isExternalIndividual ? '_blank' : undefined}
                rel={isExternalIndividual ? 'noopener noreferrer' : undefined}
              >
                <button className="bannercta__individual-button">
                  {individualButtonText}
                </button>
              </a>
            )}
            {hideContactButton ? null : (
              <a href={contactButtonUrl}>
                <button className="bannercta__contact-button">
                  {contactButtonText}
                </button>
              </a>
            )}
          </span>
        </div>
      </div>
    </>
  )
}

export default BannerCTA
